module.exports = __webpack_public_path__ + "img/yancao_shanxizhongyan_suoluetu.8d262b67.png";